import { round as lodashRound } from 'lodash-es'
import { toReadableTime } from '@/utils/time'

export function withDefault(value: number | string | null, text = '-'): string {
  switch (typeof value) {
    case 'number':
      return String(value) ? String(value) : text
    case 'string':
      return value ? value : text
    case 'object':
    default:
      return text
  }
}

export function withUnit(value: number | string | null, unit = '%'): string {
  switch (typeof value) {
    case 'number':
      return String(value) ? String(value) + unit : ''
    case 'string':
      return value ? value + unit : ''
    case 'object':
    default:
      return ''
  }
}

export function round(num: number | string | null, precision: number = 0): number | null {
  // string for NaN response
  if (num === null) {
    return null
  }

  if (typeof num === 'number') {
    return lodashRound(num, precision)
  }

  return null // expect NaN only
}

export function toReadableTimeFromTimestamp(timestamp: number | string, format?: string, timezone?: string) {
  return toReadableTime({
    timestamp: Number(timestamp),
    format: format || undefined,
    timezone: timezone || undefined,
  })
}
